// extracted by mini-css-extract-plugin
export var active = "header-module--active--6bd37";
export var avainlippuNega = "header-module--avainlippuNega--c467a";
export var avainlippuSininen = "header-module--avainlippuSininen--8a229";
export var callToActionButton = "header-module--callToActionButton--3370d";
export var callToActionWrapper = "header-module--callToActionWrapper--e4ae2";
export var container = "header-module--container--5cb9d";
export var logo = "header-module--logo--9932e";
export var logoLink = "header-module--logoLink--9eb02";
export var navLink = "header-module--navLink--8864e";
export var navLinkUrakoitsijalle = "header-module--navLinkUrakoitsijalle--9adf1";
export var navWrapper = "header-module--navWrapper--0b639";
export var openNav = "header-module--openNav--0028e";
export var subNavHeading = "header-module--subNavHeading--f8b62";
export var subNavLinkStyle = "header-module--subNavLinkStyle--1c77e";
export var subNavWrapper = "header-module--subNavWrapper--462fc";